import { ChevronDown, LogOut } from "lucide-react";
import logo from "../assets/logo.svg";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Separator } from "./ui/separator";
import { useEffect, useState } from "react";
import { user } from "../lib/api";
import { authClient } from "../auth-client";
import { Link, useNavigate } from "@tanstack/react-router";
import { formatDate, lastDayOfMonth, subMonths } from "date-fns";

const logOut = async () => {
  await authClient.signOut();
};

export function Header() {
  const [currentUser, setCurrentUser] = useState({ name: "", email: "" });
  const navigate = useNavigate();

  useEffect(() => {
    user().then(
      (user) => {
        setCurrentUser(user);
      },
      (e) => {
        if (e instanceof Error) {
          if (e.message === "Unauthorized") {
            logOut();
          }
        }
      }
    );
  }, []);

  const lastDayOfLastMonth = formatDate(lastDayOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd");
  const lastDayOfMonthBeforeLastMonth = formatDate(
    lastDayOfMonth(subMonths(new Date(), 2)),
    "yyyy-MM-dd"
  );

  return (
    <>
      <div className="px-4 py-2 flex justify-between bg-white">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="flex items-center hover:opacity-60 cursor-pointer">
              <img src={logo} alt="logo" />
              <ChevronDown className="inline" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" forceMount>
            <DropdownMenuItem asChild>
              <Link to="/">Bestellplanung</Link>
            </DropdownMenuItem>

            <DropdownMenuItem asChild>
              <Link to="/inconsistent-orders">Inkonsistente offene Mengen</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/alle">Alle Kunden</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/prognose">Prognose</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/ek-stueckliste">EK Stückliste</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/abzug-bremen">Abzug Bremen</Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Lagerauswertung</DropdownMenuLabel>
            <DropdownMenuItem asChild>
              <Link to="/lagerauswertung/wicker">Wicker (aktuell)</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/lagerauswertung/alle/$date"
                params={{
                  date: lastDayOfLastMonth,
                }}
              >
                Alle (Lager)
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/lagerauswertung/all-products/$date"
                params={{
                  date: lastDayOfLastMonth,
                }}
              >
                Alle (Produkte)
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/lagerauswertung/compare/$date/$date2"
                params={{
                  date: lastDayOfMonthBeforeLastMonth,
                  date2: lastDayOfLastMonth,
                }}
              >
                Vergleich (Lager)
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/lagerauswertung/compare-products/$date/$date2"
                params={{
                  date: lastDayOfMonthBeforeLastMonth,
                  date2: lastDayOfLastMonth,
                }}
              >
                Vergleich (Produkte)
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Avatar className="h-8 w-8 text-zinc-950 cursor-pointer">
              <AvatarImage src="" />
              <AvatarFallback>{currentUser.email.slice(0, 2).toUpperCase()}</AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" forceMount>
            <DropdownMenuLabel className="font-normal">
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium leading-none">{currentUser.name}</p>
                <p className="text-xs leading-none text-zinc-500">{currentUser.email}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                logOut();
                navigate({ to: "/" });
              }}
            >
              <LogOut size="16" />
              <span className="ml-2">Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <Separator />
    </>
  );
}
